import { FaTags } from "react-icons/fa";
import { defineField, defineType } from "sanity";
import { multilingualArrayString } from "../base";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "cruisesTagCategory",
  title: "Cruises Tag Category",
  type: "document",
  icon: FaTags,
  preview: {
    select: {
      title: "title"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title)
      };
    }
  },
  fields: [
    defineField({
      name: "title",
      title: "Title",
      type: multilingualArrayString.name,
      description: "Short title for the menu",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "cruiseCodes",
      title: "Cruise Codes",
      description: "list of cruise codes (one per row) without any comma",
      type: "text"
    })
  ]
});
